module.exports = __webpack_public_path__ + "img/check_progress.af995dcd.png";